export default function isValidAccess(id: string) {
  const Access = localStorage.getItem("Access");

  if (!Access) return true;
  const listAccess = JSON.parse(Access) as string[];
  return listAccess.includes(id);
}
